import React from "react";
import Input from "../../../../components/input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

export const IdSignForm = (props) => {
  const [showPassword, setShowPassword] = useState("");
  React.useEffect(() => {
    setShowPassword(false);
  }, []);

  return (
    <div>
      <div className="drawer-title border-none margin-top">
        Configurazione IdSign
      </div>

      <div className="input-container">
        <label className="form-label">Base Url</label>
        <Input
          id="BaseUrl"
          name="BaseUrl"
          type="text"
          placeholder="Base Url"
          onChange={(e) => props.setApiBaseUrl(e.target.value)}
          value={props.apiBaseUrl}
        />
        {props.getError("ApiBaseUrl") && (
          <div className="error-message">
            {props.getError("ApiBaseUrl").message}
          </div>
        )}
      </div>

      <div className="input-container">
        <label className="form-label">Id Cliente</label>
        <Input
          id="ClientId"
          name="ClientId"
          type="text"
          placeholder="Id cliente"
          onChange={(e) => props.setClientId(e.target.value)}
          value={props.clientId}
        />
        {props.getError("ClientId") && (
          <div className="error-message">
            {props.getError("ClientId").message}
          </div>
        )}
      </div>

      <div className="input-container">
        <label className="form-label">Secret Cliente</label>
        <FontAwesomeIcon
          onClick={() => setShowPassword(!showPassword)}
          className={`eye-icon ${showPassword && "active"}`}
          icon={faEye}
        />
        <Input
          id="ClientSecret"
          name="ClientSecret"
          type={showPassword ? "text" : "password"}
          placeholder="Secret cliente"
          onChange={(e) => props.setClientSecret(e.target.value)}
          value={props.clientSecret}
        />
        {props.getError("ClientSecret") && (
          <div className="error-message">
            {props.getError("ClientSecret").message}
          </div>
        )}
      </div>

      <div className="input-container">
        <label className="form-label">Codice del Instituzione</label>
        <Input
          id="InstitutionCode"
          name="InstitutionCode"
          type="text"
          placeholder="Codice del instituzione"
          onChange={(e) => props.setInstitutionCode(e.target.value)}
          value={props.institutionCode}
        />
        {props.getError("InstitutionCode") && (
          <div className="error-message">
            {props.getError("InstitutionCode").message}
          </div>
        )}
      </div>
    </div>
  );
};
